export const DEFAULT_ALERT_TEXT_TEMPLATE =
  'Issue with {{alertRule}} detected on {{sensorName}}. Please investigate.'

export const recipientHeaders = ['First Name', 'Last Name', 'Phone Number', 'Email']

export const maxUsersAlerted = 10
